import {invalidateQueries, q} from "../../state";
import {CreateAsset, FileId, ListAssets, AssetId} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(query: ListAssets) {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/assets`, {query});
}

export async function get(assetId: AssetId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/vendor_toolkit/assets/{asset_id}", {
    path: {asset_id: assetId},
  });
}

export async function create(asset: CreateAsset) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/assets`, {
    body: asset,
  });
  await invalidateQueries([q.vendorToolkit.assets.filter()]);
  return res;
}

export async function updateTitle(assetId: AssetId, title: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/vendor_toolkit/assets/{asset_id}/title",
    {path: {asset_id: assetId}, body: title},
  );
  await invalidateQueries([q.vendorToolkit.assets.filter(), q.vendorToolkit.asset.filter(assetId)]);
  return res;
}

export async function updateFile(assetId: AssetId, file_id: FileId) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/vendor_toolkit/assets/{asset_id}/file",
    {path: {asset_id: assetId}, body: file_id},
  );
  await invalidateQueries([q.vendorToolkit.asset.filter(assetId)]);
  return res;
}

export async function deleteAsset(assetId: AssetId) {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/vendor_toolkit/assets/{asset_id}`,
    {path: {asset_id: assetId}},
  );
  await invalidateQueries([q.vendorToolkit.assets.filter()]);
  return res;
}
